// extracted by mini-css-extract-plugin
export default {"wrap":"ActionToContinueScreen_wrap__f1MO9","title":"ActionToContinueScreen_title__Q3cxk","button":"ActionToContinueScreen_button__1Eizx"};